import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { PhotoOutlined } from "@material-ui/icons";
import { compose } from "recompose";

const styles = (theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        color: theme.actionableTextColor,
    },
    text: {
        cursor: "pointer",
        textDecoration: "underline",
        marginRight: 4
    }
});

const OccupiedCapacityRenderer = ({ classes, value }) => {
    return value && (<div className={classes.container}>
        <span className={classes.text}>
            {value}
        </span>
        <PhotoOutlined />
    </div>)
};

export default compose(withStyles(styles),withTheme())(OccupiedCapacityRenderer);
